import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { APP_FLOW, config } from '../common/constant'
import ImageLoader from '../common/image-loader'
import Footer from '../section/footer/footer'
import * as userAction from '../redux/actions/userAction';
import * as zakatCalc from '../redux/actions/zakatCalcAction';
import * as zakatAction from '../redux/actions/zakatActions';
import { tokenServices } from '../jwt/_services/token-service'
import { useDispatch } from 'react-redux'
import Loader from '../views/MUIS/loader'
import { BANK_TRANSFER_ICON, CASH_ICON, CHEQUE_ICON, DEBIT_NETS_ICON } from '../common/images-s3'
import { getAppFlow } from '../views/utils/app.utils'

const PaymentMethod = ({ setHeaderData }) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    
    const paymentMethods = [
        {
            imgPath: DEBIT_NETS_ICON,
            name: 'Debit/NETS',
            info: 'Lorem ipsum dolor sit amet',
            id: config.PAYMENT_MODE.CONTACTLESS,
            paymentType: 'Card'

        },
        {
            imgPath: CHEQUE_ICON,
            name: 'CHEQUE',
            info: 'Collect Bank issued<br/>Cheques from payers',
            id: config.PAYMENT_MODE.CHEQUE,
            paymentType: 'Cheque'

        },
        {
            imgPath: CASH_ICON,
            name: 'CASH',
            info: 'Collect Cash<br/>from payers',
            id: config.PAYMENT_MODE.CASH,
            paymentType: 'Cash'

        },
        {
            imgPath: BANK_TRANSFER_ICON,
            name: 'BANK TRANSFER',
            info: ' Collect bank transfer<br/>details from payres',
            id: config.PAYMENT_MODE.BANK_TRANSFER,
            paymentType: 'Bank Transfer'

        },
    ]
    const homepage = useSelector((state) => state.homepageReducer)
    const user = useSelector((state) => state.userReducer)
    const zakatCalculator = useSelector((state) => state.zakatCalcReducer);
    const zakatRegular = useSelector((state) => state.zakatReducer);
    const fidyah = useSelector((state) => state.fidyahReducer)
    
    const zakat = user.iscalculatorFlow ? zakatCalculator : zakatRegular;

    const getTxnPayload = () => {
        let appId = 0;
        let attributesObject = {};
        let totalAmount = 0;
    
        if (sessionStorage.getItem("flowType") == APP_FLOW.FIDYAH) {
            appId = homepage.muisZakatFidyah?.id ?? 0;
            const muisFidyah = [];
    
            const illnessRemark = String(fidyah?.illness?.remark || '').trim();
            const remarkArray = illnessRemark ? [illnessRemark] : [];
    
            if (fidyah?.haidAmount) {
                muisFidyah.push({ amount: +parseFloat(fidyah.haidAmount).toFixed(2), name: "Haid or Other Reason" });
            }
    
            if (fidyah?.illnessAmount) {
                muisFidyah.push({ amount: +parseFloat(fidyah.illnessAmount).toFixed(2), name: "Illness or Old-age", remark: remarkArray });
            }
    
            if (fidyah?.pregnancyAmount) {
                muisFidyah.push({ amount: +parseFloat(fidyah.pregnancyAmount).toFixed(2), name: "Pregnancy or Feeding" });
            }
    
            attributesObject = { muisFidyah };
            totalAmount = fidyah?.totalAmount
    
        } else {
            const zakatHartaData = [
                zakat.business, zakat.gold, zakat.insurance,
                zakat.savings, zakat.shares,
            ];
    
            let sourceList = zakatHartaData.filter(item => {
                if (item.name !== 'Zakat Fitrah') {
                    if (user.hasIRASInclusion) {
                        return parseFloat(item.amount) > 0;
                    } else {
                        return (user.isBusinessPayer && item.name === 'Business') || parseFloat(item.amount) > 0;
                    }
                } else {
                    return parseFloat(item.amount) > 0;
                }
            });
    
            sourceList = sourceList.map(item => ({
                name: item.name,
                amount: +parseFloat(item.amount).toFixed(2)
            }));
    
            const fitrahRaw = [
                zakat.zakatfitrah.type.normal,
                zakat.zakatfitrah.type.premium,
                zakat.zakatfitrah.type.variable
            ];
    
            const fitrahAmount = zakat.zakatfitrah?.amount ?? 0;
    
            let muisFitrah = [];
    
            if (fitrahAmount > 0) {
                muisFitrah = fitrahRaw.filter(item => {
                    if (item.noOfPerson > 0 && item.amount > 0) {
                        item.name = item.rate === homepage?.muisZakatFitrah?.minAmount ? 'Normal' :
                                    item.rate === homepage?.muisZakatFitrah?.maxAmount ? 'Premium' :
                                    'Variable';
                        return true;
                    }
                    return false;
                });
            }
    
            let muisHarta = [...sourceList];
            totalAmount = zakat?.totalAmount
    
            if (sourceList.length > 0 && fitrahAmount > 0) {
                muisHarta = muisHarta.filter(item => item.name !== 'Zakat Fitrah');
                attributesObject = { muisHarta, muisFitrah };
                appId = homepage?.muisZakatHarta?.id ?? 0;
            } else if (sourceList.length === 0 && fitrahAmount > 0) {
                attributesObject = { muisFitrah };
                appId = homepage?.muisZakatFitrah?.id ?? 0;
            } else {
                muisHarta = muisHarta.filter(item => item.name !== 'Zakat Fitrah');
                attributesObject = { muisHarta };
                appId = homepage?.muisZakatHarta?.id ?? 0;
            }
        }
    
        const payload = {
            charityId: homepage.charityId,
            amount: parseFloat(totalAmount).toFixed(2),
            currency: homepage?.currencyCode ?? 'SGD',
            hasIRASInclusion: user.hasIRASInclusion ?? false,
            isOthers: user?.isOthers ?? false,
            donationType: appId,
            isDeceased: user.isDeceased ?? false,
            sourceOfIncome: user.isDeceased
                ? null
                : user.isBusinessPayer
                    ? "Trade"
                    : user.hasIRASInclusion
                        ? zakat.sourceOfIncome
                        : null,
            attribute: JSON.stringify(attributesObject),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            transactionNumber: user.transactionNo ?? null
        };
    
        return payload;
    };

    const getEnrollmentPayload = () => {
        const payload = {
            name: user.userData.name || user.userData.fullname,
            email: user.userData.email,
            phoneNumber: user.userData.mobile,
            onBehalfOf: user.isOthers ? user.userData.onbehalfof : '',
            nric: user.userData.nric || user.userData.uen,
            transactionNumber: "",
            charityId: homepage?.charity?.charityId,
            ckIAgree: true,
            isCreateAccount: true,
            dateOfBirth: user.userData?.dateofbirth,
            type: user.isBusinessPayer ? config.ENROLL_CORPORATE_ID : 1,
            companyName: user.isBusinessPayer ? user.userData.companyName : '',
            postalCode: user.userData?.addressObj?.postalCode,
            blockNumber: user.userData?.addressObj?.blockNumber,
            streetName: user.userData?.addressObj?.streetName,
            buildingName: user.userData?.addressObj?.buildingName,
            address: user?.userData?.addressObj?.ADDRESS,
            country: user.userData?.addressObj?.country,
            floorNo: user.userData?.addressObj?.floorNo,
            unitNo: user.userData?.addressObj?.unitNo,
        }
        // console.log(user,'suer')
        // console.log(payload,'payload')
        return payload

    }

    const [filteredPaymentMethods, setFilteredPaymentMethods] = useState([])
    const [selectedOption, setSelectedOption] = useState({
        imgPath: '',
        name: '',
        info: '',
        id: 0,
        paymentType: ''
    })

    useEffect(() => {
        let payPartnersPaymentTypes = homepage.payPartners.map(partner => partner.paymentType);
        const filteredPaymentMethods = paymentMethods.filter(
            method => payPartnersPaymentTypes.includes(method.paymentType)
        );
        setFilteredPaymentMethods(filteredPaymentMethods)

    }, [homepage.payPartners])

    const handleSelectedOption = (value) => {
        setSelectedOption(value)

    }

    const handleNext = () => {
        setIsLoading(true)
        dispatch(userAction.updatePaymentMode(selectedOption.id))
        fetchToken()
    }

    const handleSkip = () => {

    }


    const fetchToken = () => {
        const payload = {
            txnDetails: getTxnPayload(),
            enrollmentMethod: user.userData.flow,
            searchByNric: user.isSearchByNric,
            isBusiness: user.isBusinessPayer,
            enrollmentDetails: getEnrollmentPayload(),
            contributionType: sessionStorage.getItem("flowType") == APP_FLOW.FIDYAH ? 'Fidyah' : 'Zakat',
            paymentType: selectedOption.id,
        };

        tokenServices.getToken(payload)
            .then((response) => {
                if (response.status) {
                    setIsLoading(false)
                    dispatch(userAction.updatePayerToken({
                        tokenId: response.tokenId,
                        mobile: response.phoneNo,
                        email: response.email
                    }))
                    dispatch(zakatCalc.resetZakatCalcData());
                    dispatch(zakatAction.resetZakatData());
                    dispatch(userAction.updateUserSteps({
                        title: '',
                        subTitle: '',
                        steps: 8
                    }))
                    sessionStorage.clear()

                    setHeaderData({
                        title: '',
                        subTitle: '',
                        steps: 8
                    })
                }
            })

    }


    return (
        <>
            <div className='flow-view'>
                <div className='cards-block payment-method-pg'>
                    {
                        filteredPaymentMethods.map((value, index) => {
                            return (
                                <>
                                    <div key={index} className={`common-card card-center ${selectedOption.id === value.id ? 'active' : ''}`} onClick={() => handleSelectedOption(value)}>
                                        <div className='card-left'>
                                            <div className='card-icon'>
                                                <ImageLoader type="image" src={value.imgPath}> </ImageLoader>
                                            </div>
                                            <div className='card-content'>
                                                <h4>{value.name}</h4>
                                            </div>
                                        </div>
                                        <div className='card-right custom-radio'>
                                            <input type="radio" id={value.id} defaultChecked={selectedOption.id === value.id} checked={selectedOption.id === value.id} />
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }

                </div>
            </div>
            <Footer isSkipButtonVisible={false} handleNext={handleNext} handleSkip={handleSkip} btnName={isLoading? 'Please Wait': 'Generate Token'} disabled={!selectedOption.id}/>
            {isLoading ?
                <div className='c-loader'><Loader /></div> : null
            }
        </>
    )
}

export default PaymentMethod
